import React, { FunctionComponent } from 'react';
import { faMoneyBill } from '@fortawesome/free-solid-svg-icons';
import { BrassIcon, BrassIconProps } from '.';

const BrassIconMoneyBill: FunctionComponent<BrassIconProps> = (
  props: BrassIconProps,
) => <BrassIcon {...props} icon={faMoneyBill} />;

export { BrassIconMoneyBill };
